var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6076 13.7848L56.9968 6.10012C56.9652 6.04751 56.8964 6.03362 56.849 6.07253C52.6506 9.51474 42.1011 14.213 32.6436 6.08581C32.594 6.04321 32.5175 6.05367 32.4878 6.11189C30.1809 10.6355 22.8439 19.7553 11.3791 21.0382C11.3194 21.0449 11.2772 21.0993 11.2905 21.1579C12.475 26.3811 12.658 38.0206 4.1023 43.8173C4.05005 43.8527 4.03933 43.9254 4.08371 43.9702C8.22706 48.1592 15.3163 58.6835 11.3288 68.1314C11.3002 68.1992 11.3472 68.2756 11.4207 68.274C16.3178 68.1652 26.8065 70.985 30.9447 83.2021C30.9659 83.2648 31.039 83.2941 31.0941 83.2573C35.9852 79.9892 47.7732 75.534 56.8267 83.2349C56.8796 83.2799 56.9615 83.2638 56.9867 83.1991C58.9473 78.1609 65.5991 68.3556 77.0421 68.2789C77.1088 68.2785 77.1593 68.2175 77.1409 68.1533C75.4455 62.2367 74.8734 49.3511 85.8645 43.952C85.9282 43.9207 85.9427 43.834 85.8903 43.7863L80.2911 38.6962",
    stroke: "#242529",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9874 39.2152L44.481 51.6709L81.3291 15.3418",
    stroke: "#242529",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.e4c9dd1bc274a5f2ab37ee7a14ffdc02.svg";
export { ForwardRef as ReactComponent };